module.exports = __webpack_public_path__ + "static/media/2.440f4b83.jpg";